module.exports = __webpack_public_path__ + "img/honey_pot.69532f1f.png";